import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";
import { SectionHeading } from "@/components/site/Shared";
import { ContactList } from "@/components/site/ContactList";
import { OpeningHours } from "@/components/site/OpeningHours";
import { MapFrame } from "@/components/site/MapFrame";

export const VisitUs = () => (
  <section className="py-16 lg:py-28" aria-labelledby="visit-heading" data-testid="visit-section">
    <div className="container-x">
      <SectionHeading
        id="visit-heading"
        eyebrow="Visit or contact us"
        title="Come and see the car for yourself."
        intro="Call ahead to book a viewing — we're open seven days a week."
        action={
          <Link to="/contact" className="btn btn-dark" data-testid="visit-contact-button">
            Send an enquiry <ArrowRight className="arrow" aria-hidden="true" />
          </Link>
        }
      />
      <div className="grid gap-10 lg:grid-cols-12 lg:gap-12">
        <Reveal className="lg:col-span-7">
          <MapFrame className="aspect-[4/3] sm:aspect-[16/10] lg:aspect-auto lg:h-full lg:min-h-[460px]" testId="home-map" />
        </Reveal>
        <Reveal className="grid gap-10 sm:grid-cols-2 lg:col-span-5 lg:grid-cols-1" delay={0.1}>
          <ContactList prefix="home-contact" />
          <div>
            <h3 className="mb-4 font-display text-lg font-extrabold">Opening hours</h3>
            <OpeningHours testId="home-opening-hours" />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
